PageApp.Views.AuctionPausedView = Backbone.Marionette.ItemView.extend({
  template: hbs.templates.auctionPausedView,
  modelEvents: {
    'change': 'render'
  }
})
